import { createRoot } from 'react-dom/client';
import {BrowserRouter, Routes, Route} from "react-router-dom"

import App from './App';
import {VR} from './routes/VR';
import {Live} from './routes/Live';
import {FAQ} from './routes/FAQ';
import {Workshops} from './routes/Workshops';
import {Events} from './routes/Events';
import {Vouchers} from './routes/Vouchers'
import { Osiris } from './routes/Games/Depths-Of-Osiris';
import { Dragon } from './routes/Games/Dragon-Tower';
import { Laserbots } from './routes/Games/Laserbots';
import { Manor } from './routes/Games/Manor-Of-Escape';
import { Pirates } from './routes/Games/Pirate\'s-Plague';
import { Tiberia } from './routes/Games/Space-Station-Tiberia';
import { TimeTravel } from './routes/Games/Time-Travel-Paradox';
import { RunawayTrain } from './routes/Games/Runaway-Train';
import { Parties } from './routes/Events/Parties';
import { Corporate } from './routes/Events/Corporate';
import { PageNotFound } from './routes/PageNotFound';
import RefreshTop from './RefreshTop';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
<BrowserRouter>
    <RefreshTop/>
    <Routes>
        <Route path="/" element={<App />}/>
            <Route path="VR" element={<VR />} />
            <Route path="Live" element={<Live />} />
            <Route path="FAQ" element={<FAQ />} />
            <Route path="Workshops" element={<Workshops />} />
            <Route path="Events" element={<Events />} />
            <Route path="Vouchers" element={<Vouchers/>}/>
            <Route path="Osiris" element={<Osiris/>}/>
            <Route path="Dragon" element={<Dragon/>}/>
            <Route path="Laserbots" element={<Laserbots/>}/>
            <Route path="Manor" element={<Manor/>}/>
            <Route path="Pirates" element={<Pirates/>}/>
            <Route path="Tiberia" element={<Tiberia/>}/>
            <Route path="TimeTravel" element={<TimeTravel/>}/>
            <Route path="RunawayTrain" element={<RunawayTrain/>}/>
            <Route path="Parties" element={<Parties/>}/>
            <Route path="Corporate" element={<Corporate/>}/>
            <Route path="*" element={<PageNotFound/>}/>
    </Routes>
</BrowserRouter>
); 